/* ==========================================================================
   Zapatos Obi — facets.js
   Filtros y orden de colección sin recargar:
   - El form #FacetsForm funciona también sin JS (GET clásico).
   - Con JS: serializa el form, pide la misma URL con section_id (Section
     Rendering API), reemplaza el grid y actualiza la URL (history API).
   ========================================================================== */
(function () {
  'use strict';

  var root = null;
  var form = null;
  var grid = null;
  var sectionId = null;
  var controller = null;
  var priceTimer = null;

  function init() {
    root = document.getElementById('CollectionRoot');
    if (!root) return;
    form = document.getElementById('FacetsForm');
    grid = document.getElementById('ProductGridContainer');
    sectionId = root.getAttribute('data-section-id');
    if (!grid || !sectionId) return;

    initDrawer();
    initSort();
    initInfinite();
    initPillsScroll();

    if (form) {
      form.addEventListener('change', onFormChange);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
      });
      /* Slider de precio: movimiento en vivo y casillas numéricas sincronizadas */
      form.addEventListener('input', function (e) {
        if (e.target.matches('[data-range-min], [data-range-max]')) {
          syncPriceSlider(e.target);
        }
      });
      syncAllSliders();
    }

    /* Chips de filtros activos y paginación: navegación AJAX también.
       "Cargar más" (a[rel=next][data-load-more]) añade la página siguiente a la rejilla. */
    grid.addEventListener('click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        loadNextPage();
        return;
      }
      var link = e.target.closest('.facets__chip, .facets__clear, .pagination__item[href]');
      if (!link || !link.getAttribute('href')) return;
      e.preventDefault();
      /* Al cambiar de página hay que volver arriba: si no, se sigue viendo el final de la lista */
      var esPagina = link.classList.contains('pagination__item');
      renderFromUrl(link.getAttribute('href'), true, true, esPagina);
    });

    /* Select de orden de la barra: vive fuera del form (form="FacetsForm") y en zona re-renderizable */
    grid.addEventListener('change', function (e) {
      if (e.target.matches('select[name="sort_by"]') && form) applyFilters();
    });

    window.addEventListener('popstate', function () {
      renderFromUrl(window.location.href, false);
    });
  }

  /* ---------- Slider de precio (doble tirador) ---------- */
  function syncPriceSlider(changed) {
    var wrap = changed.closest('[data-price-slider]');
    if (!wrap) return;
    var minR = wrap.querySelector('[data-range-min]');
    var maxR = wrap.querySelector('[data-range-max]');
    var fill = wrap.querySelector('[data-slider-fill]');
    var top = parseFloat(wrap.getAttribute('data-max')) || 100;

    var lo = parseFloat(minR.value);
    var hi = parseFloat(maxR.value);
    /* evitar cruce de tiradores */
    if (lo > hi) {
      if (changed === minR) {
        minR.value = hi;
        lo = hi;
      } else {
        maxR.value = lo;
        hi = lo;
      }
    }

    if (fill) {
      fill.style.left = (lo / top) * 100 + '%';
      fill.style.right = 100 - (hi / top) * 100 + '%';
    }

    /* sincronizar casillas numéricas (sin disparar el filtrado) */
    var price = wrap.parentElement.querySelector('.facets__price');
    if (price) {
      var inputs = price.querySelectorAll('input[type="number"]');
      if (inputs[0]) inputs[0].value = lo > 0 ? lo : '';
      if (inputs[1]) inputs[1].value = hi < top ? hi : '';
    }
  }

  function syncAllSliders() {
    if (!form) return;
    form.querySelectorAll('[data-price-slider] [data-range-min]').forEach(function (r) {
      syncPriceSlider(r);
    });
  }



  /* ---------- Ordenar: desplegable propio ---------- */
  /* El <select> nativo se queda en el form (es lo que se envía) pero se esconde;
     lo que se ve es el botón + panel. Como la barra se vuelve a pintar en cada
     filtrado, esto se enciende otra vez tras cada render y los clics van delegados. */
  function encenderSort() {
    var caja = document.querySelector('[data-sort]');
    if (!caja) return;
    var ui = caja.querySelector('[data-sort-ui]');
    if (!ui) return;
    ui.hidden = false;
    caja.classList.add('sortbox--js');
  }

  function abrirSort(caja, abrir) {
    if (!caja) return;
    var btn = caja.querySelector('[data-sort-toggle]');
    var menu = caja.querySelector('.sortbox__menu');
    if (!btn || !menu) return;
    if (abrir) {
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
      });
      btn.setAttribute('aria-expanded', 'true');
      var sel = menu.querySelector('.sortbox__option.is-selected') || menu.querySelector('.sortbox__option');
      if (sel) sel.focus();
    } else {
      menu.classList.remove('is-open');
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  function cerrarSorts(menos) {
    document.querySelectorAll('[data-sort] [data-sort-toggle][aria-expanded="true"]').forEach(function (b) {
      var caja = b.closest('[data-sort]');
      if (caja !== menos) abrirSort(caja, false);
    });
  }

  function initSort() {
    encenderSort();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sort-toggle]');
      if (btn) {
        var caja = btn.closest('[data-sort]');
        var abrir = btn.getAttribute('aria-expanded') !== 'true';
        cerrarSorts(caja);
        abrirSort(caja, abrir);
        return;
      }

      var opt = e.target.closest('[data-sort-option]');
      if (opt) {
        var caja2 = opt.closest('[data-sort]');
        var sel = caja2.querySelector('select[name="sort_by"]');
        var actual = caja2.querySelector('[data-sort-current]');
        caja2.querySelectorAll('[data-sort-option]').forEach(function (o) {
          var esta = o === opt;
          o.classList.toggle('is-selected', esta);
          o.setAttribute('aria-selected', esta ? 'true' : 'false');
        });
        if (actual) actual.textContent = opt.textContent.trim();
        abrirSort(caja2, false);
        var t = caja2.querySelector('[data-sort-toggle]');
        if (t) t.focus();
        if (sel) {
          sel.value = opt.getAttribute('data-value');
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      cerrarSorts(null);
    });

    document.addEventListener('keydown', function (e) {
      var abierto = document.querySelector('[data-sort] [data-sort-toggle][aria-expanded="true"]');
      if (!abierto) return;
      var caja = abierto.closest('[data-sort]');
      if (e.key === 'Escape') {
        abrirSort(caja, false);
        abierto.focus();
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      var ops = Array.prototype.slice.call(caja.querySelectorAll('[data-sort-option]'));
      var i = ops.indexOf(document.activeElement);
      var siguiente = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (siguiente < 0) siguiente = ops.length - 1;
      if (siguiente >= ops.length) siguiente = 0;
      if (ops[siguiente]) ops[siguiente].focus();
    });
  }

  /* ---------- Contadores "N productos" / "Ver N productos" (banner, cajón, botón) ---------- */
  function syncCounts(doc) {
    document.querySelectorAll('[data-facets-count]').forEach(function (el) {
      var key = el.getAttribute('data-facets-count');
      var fresh = doc.querySelector('[data-facets-count="' + key + '"]');
      if (fresh) el.textContent = fresh.textContent;
    });
  }

  /* ---------- Scroll infinito ---------- */
  var io = null;
  var loadingMore = false;

  function initInfinite() {
    if (root.getAttribute('data-infinite') !== 'true') return;
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('infinite-on');
    attachInfiniteObserver();
  }

  function attachInfiniteObserver() {
    if (!root.classList.contains('infinite-on')) return;
    if (io) io.disconnect();
    var target = grid.querySelector('.pagination');
    if (!target || !grid.querySelector('.pagination a[rel="next"]')) return;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) loadNextPage();
        });
      },
      { rootMargin: '800px 0px' }
    );
    io.observe(target);
  }

  function infiniteLoader(show) {
    var loader = grid.querySelector('.collection__loader');
    if (!loader && show) {
      loader = document.createElement('div');
      loader.className = 'collection__loader';
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-label', root.getAttribute('data-loading-label') || 'Loading');
      grid.appendChild(loader);
    }
    if (loader) loader.hidden = !show;
    /* el botón "Cargar más" muestra el estado de carga (base.css: .button.is-loading) */
    var moreBtn = grid.querySelector('[data-load-more]');
    if (moreBtn) {
      moreBtn.classList.toggle('is-loading', !!show);
      moreBtn.setAttribute('aria-disabled', show ? 'true' : 'false');
    }
  }

  function loadNextPage() {
    if (loadingMore) return;
    var nextLink = grid.querySelector('.pagination a[rel="next"]');
    if (!nextLink) return;
    loadingMore = true;
    if (io) io.disconnect();
    infiniteLoader(true);

    var u = new URL(nextLink.getAttribute('href'), window.location.origin);
    u.searchParams.set('section_id', sectionId);

    fetch(u.toString())
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#ProductGridContainer .product-grid');
        var curGrid = grid.querySelector('.product-grid');
        if (newGrid && curGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            curGrid.appendChild(li);
          });
        }
        var curPag = grid.querySelector('.pagination');
        var newPag = doc.querySelector('#ProductGridContainer .pagination');
        if (curPag) {
          if (newPag) curPag.replaceWith(newPag);
          else curPag.remove();
        }
        infiniteLoader(false);
        loadingMore = false;
        attachInfiniteObserver();
        if (window.ObiWishlist) window.ObiWishlist.sync(grid);
      })
      .catch(function () {
        infiniteLoader(false);
        loadingMore = false;
      });
  }

  /* ---------- Chips de subcategorías: scroll lateral con la rueda ---------- */
  function initPillsScroll() {
    /* Píldoras de abajo y franja de categorías de arriba: la rueda las mueve de lado */
    var tiras = document.querySelectorAll('.collection__pills, .collection__cats');
    for (var i = 0; i < tiras.length; i++) {
      (function (tira) {
        if (tira.dataset.ruedaLista === '1') return;
        tira.dataset.ruedaLista = '1';
        tira.addEventListener(
          'wheel',
          function (e) {
            if (tira.scrollWidth <= tira.clientWidth) return;
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
              tira.scrollLeft += e.deltaY;
              e.preventDefault();
            }
          },
          { passive: false }
        );
        /* deja a la vista la categoría en la que estás */
        var actual = tira.querySelector('.is-active');
        if (actual && tira.scrollWidth > tira.clientWidth) {
          tira.scrollLeft = Math.max(0, actual.offsetLeft - 16);
        }
      })(tiras[i]);
    }
  }

  /* ---------- Drawer de filtros ---------- */
  var lastOpener = null;

  function setDrawer(open) {
    var wasOpen = document.documentElement.classList.contains('facets-drawer-open');
    document.documentElement.classList.toggle('facets-drawer-open', open);
    root.querySelectorAll('[data-facets-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var panel = root.querySelector('.facets-drawer__panel');
      var first = panel && panel.querySelector('.facets-drawer__close');
      if (first) first.focus();
    } else if (wasOpen && lastOpener && document.body.contains(lastOpener)) {
      lastOpener.focus();
    }
  }

  function initDrawer() {
    /* delegado: el botón vive en zona re-renderizable */
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-facets-open]');
      if (opener) {
        lastOpener = opener;
        setDrawer(true);
        return;
      }
      if (e.target.closest('[data-facets-close]')) {
        setDrawer(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setDrawer(false);
      }
    });
  }

  function onFormChange(e) {
    /* feedback inmediato en la casilla tocada (el form NO se re-renderiza) */
    if (e.target.matches('input[type="checkbox"]')) {
      var lab = e.target.closest('label');
      if (lab) lab.classList.toggle('is-active', e.target.checked);
    }
    var isPrice = e.target.matches('input[type="number"]');
    if (isPrice) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFilters, 600);
    } else {
      applyFilters();
    }
  }

  function buildSearchParams() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    return params.toString();
  }

  function applyFilters() {
    var qs = buildSearchParams();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    /* el cambio nació en el form: NO reemplazar su HTML (rompe los taps) */
    renderFromUrl(url, true, false);
  }

  /* Actualiza contadores y estados del form sin destruir el DOM
     (reemplazarlo entero hacía perder taps en móvil). */
  function morphFacets(freshForm) {
    /* El form fresco (servidor) solo trae los valores con resultados
       (o el activo). Si una opción NO está en él, da 0 resultados. */
    var counts = {};
    freshForm.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var label = inp.closest('label');
      var c = label && label.querySelector('.facets__box-count');
      counts[inp.name + '|' + inp.value] = c ? c.textContent : '';
    });
    form.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var label = inp.closest('label');
      if (!label) return;
      var li = label.closest('li');
      var c = label.querySelector('.facets__box-count');
      var key = inp.name + '|' + inp.value;
      var hasResults = Object.prototype.hasOwnProperty.call(counts, key);
      if (c && hasResults) c.textContent = counts[key];
      label.classList.toggle('is-active', inp.checked);
      /* ocultar valores sin resultados (salvo el marcado); reaparecen
         al volver a tener resultados al cambiar la selección */
      if (li) {
        var visible = hasResults || inp.checked;
        li.style.display = visible ? '' : 'none';
        li.hidden = !visible;
      }
    });
  }

  /* Vuelve al principio de los resultados (barra de filtros), bajo la cabecera fija */
  function subirAResultados() {
    if (!grid) return;
    var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--obi-sticky-offset')) || 0;
    var y = window.scrollY + grid.getBoundingClientRect().top - off - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function renderFromUrl(url, push, replaceForm, scrollUp) {
    if (replaceForm === undefined) replaceForm = true;
    if (controller) controller.abort();
    controller = new AbortController();

    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);

    grid.setAttribute('aria-busy', 'true');

    fetch(u.toString(), { signal: controller.signal })
      .then(function (r) {
        /* Sin esto, una respuesta 429 (la tienda corta por exceso de peticiones) o un 500
           se parseaban como si fueran la página buena: los contadores se iban al garete y
           la rejilla se quedaba a medias. Si falla, se recarga de verdad y el cliente ve
           sus resultados. */
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshGrid = doc.getElementById('ProductGridContainer');
        if (freshGrid) grid.innerHTML = freshGrid.innerHTML;

        /* Contadores "N productos" del banner, del cajón y del botón "Ver N productos" */
        syncCounts(doc);

        /* Refrescar también la barra de facetas (contadores/badges) */
        var freshForm = doc.getElementById('FacetsForm');
        if (freshForm && form) {
          if (replaceForm) {
            var openLabels = [];
            form.querySelectorAll('[data-facet-group][open] .facets__summary').forEach(function (s) {
              openLabels.push(s.textContent.trim().split('\n')[0]);
            });
            form.innerHTML = freshForm.innerHTML;
            /* restaurar dropdowns abiertos */
            form.querySelectorAll('[data-facet-group]').forEach(function (d) {
              var label = d.querySelector('.facets__summary').textContent.trim().split('\n')[0];
              if (openLabels.indexOf(label) !== -1) d.setAttribute('open', '');
            });
            syncAllSliders();
          } else {
            morphFacets(freshForm);
          }
        }

        grid.removeAttribute('aria-busy');
        encenderSort();
        initPillsScroll();
        if (scrollUp) subirAResultados();
        attachInfiniteObserver();
        if (window.ObiWishlist) window.ObiWishlist.sync(grid);

        if (push) {
          var clean = new URL(u.toString());
          clean.searchParams.delete('section_id');
          window.history.pushState({}, '', clean.toString());
        }
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          grid.removeAttribute('aria-busy');
          window.location.href = url; // fallback: recarga clásica
        }
      });
  }


  /* Acordeón de filtros: solo uno abierto a la vez. El evento toggle de <details>
     NO burbujea, por eso se escucha en fase de captura desde el documento (así
     sigue funcionando con los grupos que llegan al re-renderizar por AJAX). */
  document.addEventListener(
    'toggle',
    function (e) {
      var det = e.target;
      if (!det || det.nodeType !== 1 || !det.matches || !det.matches('[data-facet-group]') || !det.open) return;
      var abiertos = document.querySelectorAll('[data-facet-group][open]');
      for (var i = 0; i < abiertos.length; i++) {
        if (abiertos[i] !== det) abiertos[i].removeAttribute('open');
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
